/**
 * Most procedure calls one browser request may batch. The link and the handler share it:
 * above the handler's limit a batch is rejected, and each call can fan out to upstreams.
 */
export const ORPC_BATCH_MAX_SIZE = 10

/**
 * Wall clock one `/api/orpc` request may spend upstream, every procedure in its batch included.
 *
 * It sits under the route's 20-second `maxDuration`, leaving time to serialize the response, so a
 * read cut off at the deadline still reaches the browser as a fallback value or a typed error
 * instead of the platform killing the request.
 */
export const ORPC_REQUEST_DEADLINE_MS = 18_000
